if (!customElements.get('sok-product')) {
  class SokProduct extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-sok-product-data]').textContent);
      this.form = this.querySelector('[data-sok-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.qty = this.querySelector('[data-qty]');
      this.cta = this.querySelector('[data-cta]');
      this.bar = this.querySelector('[data-bar]');
      this.stage = this.querySelector('.sok-acc__stage');
      this.images = [...this.querySelectorAll('.sok-acc__img')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.index = 0;
      this.variant = this.data.variants.find((v) => v.id === Number(this.idInput.value));

      this.stage?.classList.add('is-ready');
      this.show(0);
      this.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => this.show(this.index + Number(b.dataset.step))));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.thumb))));

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option]')) this.onOption();
        if (e.target.matches('[data-qty]')) this.renderCta();
      });
      this.querySelectorAll('[data-qty-step]').forEach((b) =>
        b.addEventListener('click', () => {
          this.qty.value = Math.min(99, Math.max(1, Number(this.qty.value) + Number(b.dataset.qtyStep)));
          this.renderCta();
        })
      );
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.bar?.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        this.form.requestSubmit();
      });

      if (this.bar) {
        new IntersectionObserver(([entry]) => {
          // Shown whenever the main button is off screen, above or below, as in the design.
          const on = !entry.isIntersecting;
          this.bar.classList.toggle('is-on', on);
          this.bar.setAttribute('aria-hidden', String(!on));
        }).observe(this.cta);
      }
      this.markUnavailable();
    }

    show(i) {
      if (!this.images.length) return;
      this.index = (i + this.images.length) % this.images.length;
      this.images.forEach((img, n) => img.classList.toggle('is-active', n === this.index));
      this.thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.thumb) === this.index));
    }

    selected() {
      const options = [];
      this.querySelectorAll('[data-option]:checked').forEach((i) => (options[Number(i.dataset.option) - 1] = i.value));
      return options;
    }

    onOption() {
      const options = this.selected();
      this.variant = this.data.variants.find((v) => v.options.every((o, i) => o === options[i]));
      options.forEach((value, i) => {
        const label = this.querySelector(`[data-option-label="${i + 1}"]`);
        if (label) label.textContent = value;
      });
      if (this.variant) {
        this.idInput.value = this.variant.id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url);
        if (this.variant.media) {
          const i = this.data.mediaIds.indexOf(this.variant.media);
          if (i >= 0) this.show(i);
        }
        this.querySelector('[data-price]').textContent = this.money(this.variant.price);
        const sub = this.querySelector('[data-bar-sub]');
        if (sub) sub.textContent = `${options.join(' / ')} · ${this.money(this.variant.price)}`;
      }
      this.markUnavailable();
      this.renderCta();
    }

    // Grey out values that have no available variant with the other current choices.
    markUnavailable() {
      const options = this.selected();
      this.querySelectorAll('[data-option]').forEach((input) => {
        const pos = Number(input.dataset.option) - 1;
        const trial = [...options];
        trial[pos] = input.value;
        const match = this.data.variants.find((v) => v.options.every((o, i) => o === trial[i]));
        input.closest('.sok-acc__value').classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    money(cents) {
      const whole = cents % 100 === 0;
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: this.data.currency || 'AUD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    }

    renderCta(state) {
      const label = this.cta.querySelector('[data-cta-label]');
      const s = this.data.strings;
      this.cta.classList.toggle('is-done', state === 'done');
      if (state === 'loading') {
        label.innerHTML =
          '<svg class="sok-spinner" width="22" height="22" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="7" fill="none" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M9 2a7 7 0 0 1 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        return;
      }
      if (state === 'done') {
        label.innerHTML = `<svg class="sok-tick" width="22" height="22" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="var(--sok-stone)"/><path d="M5.2 9.3l2.5 2.5 5-5.3" fill="none" stroke="var(--sok-success)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sok-fade-in">${s.added}</span>`;
        return;
      }
      const available = this.variant && this.variant.available;
      this.cta.disabled = !available;
      label.textContent = available ? `${s.addToCart} · ${this.money(this.variant.price * Number(this.qty.value || 1))}` : s.soldOut;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.variant?.available || this.busy) return;
      this.busy = true;
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      this.renderCta('loading');
      const drawer = document.querySelector('cart-drawer');
      const sections = ['cart-icon-bubble'];
      if (drawer?.getSectionsToRender) drawer.getSectionsToRender().forEach((x) => sections.push(x.id));
      const started = Date.now();
      try {
        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: this.variant.id, quantity: Number(this.qty.value) || 1 }],
            sections: [...new Set(sections)],
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Cart error');
        await new Promise((r) => setTimeout(r, Math.max(0, 750 - (Date.now() - started))));
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && result.sections?.['cart-icon-bubble']) {
          const doc = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          bubble.innerHTML = doc.querySelector('.shopify-section')?.innerHTML ?? doc.body.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sok-product', productVariantId: this.variant.id, cartData: result });
        }
        if (drawer?.renderContents) drawer.renderContents({ ...result, id: this.variant.id });
        this.renderCta('done');
        setTimeout(() => this.renderCta(), 1800);
      } catch (e) {
        this.renderCta();
        error.textContent = this.data.strings.error;
        error.hidden = false;
      } finally {
        this.busy = false;
      }
    }
  }

  customElements.define('sok-product', SokProduct);
}
